import React from 'react';
// import _ from 'lodash';
import PropTypes from 'prop-types';
import { CardFooter, CardFooterLeft, CardFooterRight } from '../bootstrap/Card';
import Button from '../bootstrap/Button';
import Spinner from '../bootstrap/Spinner';
import Alert from '../bootstrap/Alert';
import { navigateBackwardToPage } from '../../utils/genericFuncs';

const InfoCollectFooter = ({
	prevPage,
	stepNum,
	setStepNum,
	setActivePageName,
	hasErrors,
	setHasErrors,
	errorString,
	isSubmitting,
	setIsSubmitting,
	isSaving,
	setIsSaving,
	setProceedToNextPage,
	// THis async function takes an array of formiks and checks their validity
	// Returns true if formiks are valid, false if not.
	formsAreValidFunc,
	updateConfirmationArray,
	continueButtonText,
	// This async function is used to save data via endpoint and update the local current vehicle.
	// Each infoCollect page has a slightly different one so we pass it in.
	onClickSaveDataFunction,
	// autoTerminateIsSubmitting,
	// This async function is used to override the navigation behavior of the continue button
	customOnClickContinueFunction,
	customOnClickContinueFunctionData,
	formikArray,
	// Optional props to control navigation
	saveButtonIsHidden,
	continueButtonIsHidden,
	backButtonIsHidden,
	// If we want to stack any components above the buttons
	additionalComponents,
}) => {
	// Staple back function takes you to prevPage
	const backButtonFunction = () => {
		navigateBackwardToPage(stepNum, prevPage, setStepNum, setActivePageName);
	};

	const saveButtonFunction = async () => {
		// Check if forms are valid
		let thisHasErrors;
		try {
			thisHasErrors = await formsAreValidFunc(formikArray);
		} catch (error) {
			thisHasErrors = true;
			return;
		}
		setHasErrors(thisHasErrors);
		if (thisHasErrors === true) {
			// Has errors so don't continue
			return;
		}
		setIsSaving(true);
		updateConfirmationArray();
		await onClickSaveDataFunction();
		setIsSaving(false);
	};

	const continueButtonFunction = async () => {
		// Check if forms are valid
		let thisHasErrors;
		try {
			thisHasErrors = await formsAreValidFunc(formikArray);
		} catch (error) {
			thisHasErrors = true;
			return;
		}
		setHasErrors(thisHasErrors);
		if (thisHasErrors === true) {
			return;
		}
		setIsSubmitting(true);
		try {
			if (customOnClickContinueFunction) {
				await onClickSaveDataFunction();
				await customOnClickContinueFunction(customOnClickContinueFunctionData);
			} else {
				setProceedToNextPage(true);
				updateConfirmationArray();
				await onClickSaveDataFunction();
			}
		} catch (error) {
			setProceedToNextPage(false);
			setIsSubmitting(false);
		}
	};
	return (
		<CardFooter
			className={hasErrors === true || additionalComponents.length > 0 ? 'flex-column' : ''}>
			{hasErrors === true && (
				<div className='col-12'>
					<Alert color='danger' isOutline>
						{errorString}
					</Alert>
				</div>
			)}
			{additionalComponents.length > 0 && (
				<>
					<div className='col-12'>{additionalComponents}</div>
					<br />
				</>
			)}
			<div
				className={
					hasErrors === true || additionalComponents.length > 0
						? 'col-12 d-flex'
						: 'col-12 d-flex flex-row'
				}>
				<CardFooterLeft>
					{backButtonIsHidden === false && (
						<Button
							color='info'
							// size='lg'
							isOutline
							disabled={isSubmitting || isSaving}
							onClick={backButtonFunction}>
							Back
						</Button>
					)}
				</CardFooterLeft>
				<CardFooterRight>
					{saveButtonIsHidden === false && (
						<Button
							color='info'
							isLight
							disabled={isSubmitting || isSaving}
							// size='lg'
							onClick={saveButtonFunction}>
							{isSaving && (
								<Spinner
									isSmall
									// inButton
									color='dark'
									// style={{ 'border-width': '0.1em' }}
								/>
							)}
							{!isSaving && <div>Save</div>}
						</Button>
					)}
					{continueButtonIsHidden === false && (
						<Button
							color='info'
							// size='lg'
							data-testid='continue-button'
							disabled={isSubmitting || isSaving}
							onClick={continueButtonFunction}>
							{isSubmitting && <Spinner isSmall color='dark' />}
							{isSubmitting ? '' : continueButtonText}
						</Button>
					)}
				</CardFooterRight>
			</div>
		</CardFooter>
	);
};

InfoCollectFooter.propTypes = {
	setStepNum: PropTypes.func.isRequired,
	stepNum: PropTypes.number.isRequired,
	setActivePageName: PropTypes.func.isRequired,
	hasErrors: PropTypes.bool.isRequired,
	setHasErrors: PropTypes.func.isRequired,
	errorString: PropTypes.string,
	isSubmitting: PropTypes.bool.isRequired,
	setIsSubmitting: PropTypes.func.isRequired,
	continueButtonText: PropTypes.string.isRequired,
	onClickSaveDataFunction: PropTypes.func.isRequired,
	isSaving: PropTypes.bool.isRequired,
	setIsSaving: PropTypes.func.isRequired,
	setProceedToNextPage: PropTypes.func.isRequired,
	formsAreValidFunc: PropTypes.func.isRequired,
	updateConfirmationArray: PropTypes.func.isRequired,
	// eslint-disable-next-line react/forbid-prop-types
	formikArray: PropTypes.arrayOf(PropTypes.object).isRequired,
	saveButtonIsHidden: PropTypes.bool,
	continueButtonIsHidden: PropTypes.bool,
	backButtonIsHidden: PropTypes.bool,
	// eslint-disable-next-line react/forbid-prop-types
	additionalComponents: PropTypes.array,
	prevPage: PropTypes.string.isRequired,
	customOnClickContinueFunction: PropTypes.func,
	// eslint-disable-next-line react/forbid-prop-types
	customOnClickContinueFunctionData: PropTypes.object,
	// autoTerminateIsSubmitting: PropTypes.bool,
};
InfoCollectFooter.defaultProps = {
	saveButtonIsHidden: false,
	continueButtonIsHidden: false,
	backButtonIsHidden: false,
	additionalComponents: [],
	errorString: 'Fix errors before continuing',
	customOnClickContinueFunction: null,
	customOnClickContinueFunctionData: {},
	// autoTerminateIsSubmitting: true,
};

export default InfoCollectFooter;
